module.exports = __webpack_public_path__ + "img/keiki-telling-joke.c273fa5d.png";